import { render, staticRenderFns } from "./SettingsGroupManager.vue?vue&type=template&id=32d8f9b3"
import script from "./SettingsGroupManager.vue?vue&type=script&lang=js"
export * from "./SettingsGroupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports